import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';

interface SearchSortFilterBarProps {
  totalItems: number;
  sortBy: 'relevance' | 'new' | 'popular' | 'price_low' | 'price_high';
  onSortChange: (sortBy: 'relevance' | 'new' | 'popular' | 'price_low' | 'price_high') => void;
  onFilterClick?: () => void;
}

const SearchSortFilterBar: React.FC<SearchSortFilterBarProps> = ({
  totalItems,
  sortBy,
  onSortChange,
  onFilterClick,
}) => {
  const { t } = useTranslation();

  const handleFilterClick = () => {
    if (onFilterClick) {
      onFilterClick();
    } else {
      console.log('Filter clicked');
    }
  };

  return (
    <Container maxWidth="lg" sx={{ pt: { xs: 0, md: 0 } }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
        }}
      >
        <Typography 
          sx={{ 
            fontWeight: 'bold',
            fontSize: '16px'
          }}
        >
          {totalItems} {t('common.items')}
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 1 }}>
          {/* Sort Dropdown */}
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <Select
              value={sortBy}
              onChange={(e) => onSortChange(e.target.value as 'relevance' | 'new' | 'popular' | 'price_low' | 'price_high')}
              IconComponent={() => (
                <img
                  src="/icons/icon_filter.png"
                  alt="Filter"
                  style={{
                    width: 16,
                    height: 16,
                    display: 'block',
                    marginRight: 8,
                  }}
                />
              )}
              sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#E0E0E0',
                  },
                  '&:hover fieldset': {
                    borderColor: '#E0E0E0',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#E0E0E0',
                  },
                },
              }}
            >
              <MenuItem value="relevance">{t('search.relevance')}</MenuItem>
              <MenuItem value="new">{t('common.new')}</MenuItem>
              <MenuItem value="price_low">{t('common.priceLow')}</MenuItem>
              <MenuItem value="price_high">{t('common.priceHigh')}</MenuItem>
            </Select>
          </FormControl>

          {/* Filter Button */}
          <Button
            variant="outlined"
            onClick={handleFilterClick}
            sx={{
              borderColor: '#E0E0E0',
              color: '#000',
              textTransform: 'none',
              fontSize: '14px',
              px: 2,
              py: 1,
              borderRadius: 2,
              minWidth: 'auto',
              '&:hover': {
                borderColor: '#E0E0E0',
                backgroundColor: '#F5F5F5',
              },
            }}
          >
            <img
              src="/icons/icon_filter.png"
              alt="Filter"
              style={{
                width: 16,
                height: 16,
                display: 'block',
              }}
            />
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default SearchSortFilterBar;
